import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Flow } from '@/interfaces/requirement';

@Component({
  selector: 'app-flow-state',
  templateUrl: './flow-state.component.html',
  styleUrls: ['./flow-state.component.css'],
})
export class FlowStateComponent implements OnInit {

  @Input() step!: Flow;
  @Input() variant!: string;
  @Input() withDate!: boolean;
  @Input() first!: boolean;
  @Input() last!: boolean;

  text: string = '';
  show = false;
  timeout: any;

  mounted = true;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    let text = '';
    if (this.step.delegator) {
      text = `${this.step.delegator} lo delego a ${this.step.assigned}`;
    }
    else {
      text = this.step.assigned || this.step.roleName;
    }
    this.text = text;
  }

  onHover() {
    if (this.variant === 'full') {
      this.show = true;
      this.mounted = true;
    }
  }

  onLeaving() {
    this.timeout = setTimeout(() => {
      this.show = false;
      this.cdr.detectChanges();
    }, 300);

    this.timeout = setTimeout(() => {
      this.mounted = false;
      this.cdr.detectChanges();
    }, 600);
  }

}
